/* DemoPool free tools → straight to cart (20.10.2026, owner: "Our goal is to sell the product").
   Data: snippets/dp-tool-buy.liquid (#dp-buy-json: real Shopify one-time variants per list + facts genre/group counts).
   Root: [data-buy=<key>] data-buy-genre=<slug|g-group|all> (or data-buy-gtext=<free text genre>) data-buy-src=<tool slug>.
   Inside: [data-buy-go] click target · [data-buy-p] price · [data-buy-n] scope ("R&B curators") · [data-buy-note] fallback note
   · [data-buy-more] "see all options" link (href follows the key). Tools only change data-buy / data-buy-genre / data-buy-gtext; this file redraws.
   Match rule: the genre's own file → its genre group file → the all-genres file (the note says which one the user gets).
   Click: already in the cart → open the mini-cart; else POST /cart/add.js → dp:cart {added} → assets/dp-cart.js opens the mini-cart.
   No mini-cart → /cart. AJAX error → GET /cart/add?id=…&quantity=1 (Shopify adds and redirects to /cart). No JS → the link's href (collection). */
(() => {
  const el0 = document.getElementById('dp-buy-json'); if (!el0) return;
  let D; try { D = JSON.parse(el0.textContent); } catch (_) { return; }
  const ok = s => !!s && !/\[\[/.test(String(s));
  const norm = t => ' ' + String(t || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
  // free text genre → shop genre slug, most specific first (same table as the 09.10 tool offer)
  const ALIAS = [
    ['melodic techno|melodic house|progressive|melodic', 'melodic-and-progressive'], ['hard techno|hard dance|hardstyle|hardcore', 'hard-techno-and-hard-dance'],
    ['afro house|afro|amapiano', 'afro-house-and-amapiano'], ['deep house|organic house', 'deep-and-organic-house'], ['tech house', 'tech-house'],
    ['indie dance|electronica|nu disco', 'indie-dance-and-electronica'], ['uk garage|ukg|garage|breaks|breakbeat', 'uk-garage-and-breaks'],
    ['drum and bass|dnb|d and b|jungle|liquid', 'drum-and-bass'], ['dubstep|riddim|bass music|bass', 'bass-and-dubstep'],
    ['hip hop|hiphop|rap|trap|drill|boom bap|phonk', 'hip-hop-and-trap'], ['r and b|rnb|r n b|soul|neo soul', 'r-and-b'],
    ['lo fi|lofi|ambient|chill|downtempo', 'downtempo-and-ambient'], ['reggaeton|latin|salsa|bachata', 'latin'], ['reggae|dancehall', 'reggae-and-dancehall'],
    ['country|folk|americana', 'country-and-folk'], ['jazz|blues', 'jazz-and-blues'], ['classical|soundtrack|score|orchestral', 'classical-and-soundtrack'],
    ['gospel|christian|worship', 'christian-and-gospel'], ['metal', 'metal'], ['trance', 'trance'], ['techno', 'techno'], ['house', 'house'],
    ['pop', 'pop-and-dance-pop'], ['rock|indie|punk|alternative|alt', 'indie-and-rock']
  ].map(([w, s]) => [new RegExp(' (' + w + ') '), s]);
  const TREE = D.tree || [], NAMES = D.names || {};
  const slugOf = text => {
    const t = norm(text); if (t === '  ') return 'all';
    const id = t.trim().replace(/ /g, '-'); if (NAMES[id]) return id;
    for (const s in NAMES) if (norm(NAMES[s]) === t) return s;
    for (const [re, s] of ALIAS) if (re.test(t)) return s;
    return 'all';
  };
  const groupOf = slug => TREE.find(g => g[2].indexOf(slug) > -1);
  const cap = s => s.charAt(0).toUpperCase() + s.slice(1);

  // key + genre → { v:[id,cents,fmt], kind:'genre'|'group'|'all', name, scope, note, label, count }
  const pick = (key, genre, country) => {
    const p = D.p && D.p[key]; if (!p) return null;
    const V = p.v || {}, all = V.all;
    let slug = genre || 'all';
    // US slice (owner 20.10): label finder with Country = US and a genre that has a US file; no count until facts has US slices (ND #53)
    if (country === 'US' && slug !== 'all' && V['us-' + slug]) {
      const gname = NAMES[slug] || slug;
      return { v: V['us-' + slug], kind: 'country', name: 'US ' + gname, scope: 'US ' + gname + ' ' + p.s, count: (p.us && p.us[slug]) || '', note: 'US labels only, every ' + gname + ' label in the US file.', label: 'US ' + gname + ' · ' + p.n };
    }
    if (key === 'all-access') return all ? { v: all, kind: 'all', name: '', scope: 'All Access', count: ok(p.total) ? p.total : '', note: '', label: 'All Access: full file' } : null;
    if (slug.indexOf('g-') === 0) {
      const g = TREE.find(x => x[0] === slug.slice(2));
      if (g && V[slug]) return { v: V[slug], kind: 'group', name: g[1], scope: g[1] + ' ' + p.s, count: p.gr[g[0]] || '', note: '', label: g[1] + ' · ' + p.n };
      slug = 'all';
    }
    if (slug !== 'all') {
      const gname = NAMES[slug] || cap(slug.replace(/-and-/g, ' & ').replace(/-/g, ' '));
      if (V[slug]) return { v: V[slug], kind: 'genre', name: gname, scope: gname + ' ' + p.s, count: p.g[slug] || '', note: '', label: gname + ' · ' + p.n };
      const g = groupOf(slug);
      if (g && V['g-' + g[0]]) {
        const c = p.gr[g[0]];
        return { v: V['g-' + g[0]], kind: 'group', name: g[1], scope: g[1] + ' ' + p.s, count: c || '', label: g[1] + ' · ' + p.n,
          note: gname + ' is part of the ' + g[1] + ' file' + (ok(c) ? ' (' + c + ' ' + p.s + ')' : '') + '.' };
      }
      if (all) return { v: all, kind: 'all', name: '', scope: 'all ' + p.s, count: ok(p.total) ? p.total : '', label: 'All genres · ' + p.n,
        note: 'No separate ' + gname + ' file yet. The full list covers every genre, ' + gname + ' included.' };
    }
    return all ? { v: all, kind: 'all', name: '', scope: 'all ' + p.s, count: ok(p.total) ? p.total : '', note: '', label: 'All genres · ' + p.n } : null;
  };

  const countryOf = r => (r.dataset.buyCountry || '').toUpperCase();
  const genreOf = r => r.dataset.buyGenre || (r.dataset.buyGtext != null ? slugOf(r.dataset.buyGtext) : 'all');
  const sync = r => {
    const key = r.dataset.buy, m = pick(key, genreOf(r), countryOf(r)), p = D.p && D.p[key];
    r._m = m;
    r.classList.toggle('is-nobuy', !m);
    r.querySelectorAll('[data-buy-p]').forEach(x => { x.textContent = m ? m.v[2] : ''; });
    r.querySelectorAll('[data-buy-n]').forEach(x => { x.textContent = m ? m.scope : (p ? p.s : ''); });
    r.querySelectorAll('[data-buy-note]').forEach(x => { x.textContent = m ? m.note : ''; x.hidden = !(m && m.note); });
    r.querySelectorAll('[data-buy-more]').forEach(x => { if (p) x.href = p.col + '#pick'; });
    r.querySelectorAll('[data-buy-min]').forEach(x => { x.textContent = p && p.min ? p.min : ''; });
    // "from $X" only when a cheaper option than the matched file exists
    r.querySelectorAll('[data-buy-minw]').forEach(x => { x.hidden = !(m && p && p.min && p.min !== m.v[2]); });
    const go = r.matches('[data-buy-go]') ? r : r.querySelector('[data-buy-go]');
    if (go && m) go.setAttribute('aria-label', 'Add ' + m.scope + ' to cart, ' + m.v[2] + ', one-time file');
  };

  const J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const cartJs = () => fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(x => x.ok ? x.json() : Promise.reject(x));
  const track = (src, m, what) => {
    try { (window.dpEvent || ((n, p) => (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: n }, p))))('tool_cta', { tool: src, cta: what, match: m.kind, variant: m.v[0], value: m.v[1] / 100 }); } catch (_) {}
    try { window.clarity && window.clarity('event', 'tool_' + what); } catch (_) {}
  };
  const tell = (cart, m) => {
    document.dispatchEvent(new CustomEvent('dp:cart', { detail: { cart, added: { name: cap(m.scope), detail: 'One-time file', price: m.v[2] } } }));
    if (!window.dpCart) location.href = '/cart';
  };
  let busy = false;
  const buy = (r, go) => {
    const m = r._m; if (!m || busy) return;
    busy = true; go.classList.add('is-busy'); go.setAttribute('aria-busy', 'true');
    const src = r.dataset.buySrc || 'tool', id = m.v[0];
    const done = () => { busy = false; go.classList.remove('is-busy'); go.removeAttribute('aria-busy'); };
    const hard = () => { location.href = '/cart/add?id=' + id + '&quantity=1'; };
    cartJs().catch(() => ({ items: [] })).then(c => {
      if ((c.items || []).some(l => l.variant_id === id)) {
        track(src, m, 'view_cart'); done();
        return window.dpCart ? window.dpCart.open() : (location.href = '/cart');
      }
      track(src, m, 'add_to_cart');
      return fetch('/cart/add.js', { method: 'POST', headers: J, credentials: 'same-origin', body: JSON.stringify({ items: [{ id, quantity: 1, properties: { List: m.label, _source: 'tool-' + src } }] }) })
        .then(x => x.ok ? x.json() : Promise.reject(x))
        .then(cartJs)
        .then(cart => { done(); tell(cart, m); }, () => { done(); hard(); });
    });
  };

  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const init = r => {
    if (r._dpb) return; r._dpb = 1;
    // optional genre select for tools without a genre field (royalty calculator, release planner): [data-buy-gsel]
    const gs = r.querySelector('[data-buy-gsel]');
    if (gs) {
      if (gs.options.length < 2) gs.insertAdjacentHTML('beforeend', Object.keys(NAMES).sort((a, b) => NAMES[a].localeCompare(NAMES[b])).map(k => '<option value="' + esc(k) + '">' + esc(NAMES[k]) + '</option>').join(''));
      gs.value = r.dataset.buyGenre || 'all';
      gs.addEventListener('change', () => { r.dataset.buyGenre = gs.value; });
    }
    // optional list chooser (email checker, hub): one select of lists, the CTA then adds that list's all-genres file
    const ls = r.querySelector('[data-buy-lsel]');
    if (ls) { ls.value = r.dataset.buy; ls.addEventListener('change', () => { r.dataset.buy = ls.value; }); }
    sync(r);
    new MutationObserver(() => sync(r)).observe(r, { attributes: true, attributeFilter: ['data-buy', 'data-buy-genre', 'data-buy-gtext', 'data-buy-country'] });
    r.addEventListener('click', e => {
      const go = e.target.closest('[data-buy-go]'); if (!go || !r.contains(go) || !r._m) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // new tab = browse the collection
      e.preventDefault(); buy(r, go);
    });
  };
  const boot = () => document.querySelectorAll('[data-buy]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  window.dpBuy = { pick, slugOf, sync, boot, data: D };
})();
